import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAxq00RP-FEgfrLEKwNER8p3jyiFUH3I84",
  authDomain: "sales-tracking-2026.firebaseapp.com",
  projectId: "sales-tracking-2026",
  storageBucket: "sales-tracking-2026.firebasestorage.app",
  messagingSenderId: "133546373143",
  appId: "1:133546373143:web:61c4a13d2f0de1a298ac52",
  measurementId: "G-3HFK9RVK9N"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);